import React, { useEffect, useState, createContext, useContext } from 'react';
type PlatformContextType = {
  isAfterTide: boolean;
  togglePlatform: () => void;
};
const PlatformContext = createContext<PlatformContextType | undefined>(undefined);
export const PlatformProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [isAfterTide, setIsAfterTide] = useState<boolean>(() => {
    const saved = localStorage.getItem('platform');
    return saved === 'aftertide';
  });
  useEffect(() => {
    localStorage.setItem('platform', isAfterTide ? 'aftertide' : 'litlaunch');
  }, [isAfterTide]);
  const togglePlatform = () => {
    setIsAfterTide(prev => !prev);
  };
  return <PlatformContext.Provider value={{
    isAfterTide,
    togglePlatform
  }} data-id="element-4123" data-mp="2g5nvc0tfsjyf">
      {children}
    </PlatformContext.Provider>;
};
export const usePlatform = (): PlatformContextType => {
  const context = useContext(PlatformContext);
  if (context === undefined) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }
  return context;
};